var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{staticClass:"main"},[_c('a-layout',[(_vm.device === 'desktop')?[_c('a-layout-sider',[_c('catelog')],1)]:_vm._e(),_c('a-layout-content',[_c('router-view')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }